/**
 * The logo's own geometry — two nodes joined by a concave metaball neck.
 * Every ornament in the v2 language is this shape rescaled; never a new
 * primitive. Shared by the landing hero and the reports page.
 */
export function NodePair({ fill }: { fill: string }) {
  return (
    <svg viewBox="0 0 444 434" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
      <g fill={fill}>
        <circle cx="122" cy="120" r="85" />
        <circle cx="318" cy="318" r="92" />
        <path d="M61.6,179.8 C158.6,214.1 224.6,280.1 252.6,382.7 L383.4,253.3 C281.4,223.9 215.4,157.9 182.4,60.2 Z" />
      </g>
    </svg>
  );
}
